var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menuTwo"},[_c('breadCrumb'),_c('base-table',{attrs:{"tableData":_vm.tableData},on:{"handleClick":_vm.handleClick}}),_c('pagination',{attrs:{"paginationDatas":_vm.paginationDataProduct},on:{"sizePageChange":_vm.paginationChangeProduct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }